<template>
	<app-page>
		<app-heading :title="`Cron Jobs (${now.utc().format('HH:mm:ss')})`">
			<template v-slot:left>
				<app-button v-if="$ravello.can('system.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					small
					outlined
					:to="{ name: 'system-cron-job', params: { job: 'new' } }"
				>Add Job</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="jobs"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchCronJobs"
				>
					<template v-slot:interval="{ item }">
							<div v-if="item.interval">{{ item.interval | timelapse }}</div>
							<div v-else>1d 0h 0m 0s ({{item.time}})</div>
					</template>
					<template v-slot:ttl="{ item }">
						<div v-if="!item.disabled">{{ item.ttl || 0 | timelapse }}</div>
						<div v-else><i>DISABLED</i></div>
					</template>
					<template v-slot:actions="{ item }">
							<app-button
								v-if="$ravello.can('system.put')"
								color="secondary"
								:to="{ name: 'system-cron-job', params: { job: item._id } }"
								icon="fa-pencil-alt"
								table
							>
								Edit
							</app-button>
							<app-button-confirm
								v-if="$ravello.can('source.delete')"
								color="error"
								icon="fa-trash"
								table
								label-confirm="Remove"
								:description="`<b>If this is not a temporary cron job, `
									+ `please *DISABLE* the cron job instead to prevent future conflict with old `
									+ `listeners.</b>`
									+ `<br />Are you sure you want to remove job <b>${item.display_name}</b>?`"
								title="Remove Job"
								@click="onDelete(item._id)"
							>
								Remove
							</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'system-cron-job', params: { job: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
import moment from 'moment'

export default {
	data() {
		return {
			now: moment(),
			jobs: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Name',
				value: 'display_name',
				sortable: true,
			}, {
				text: 'Interval',
				value: 'interval',
				sortable: false,
			}, {
				text: 'Remaining',
				value: 'ttl',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
			updateInterval: null,
		}
	},
	created() {
		this.updateRemaining()
	},
	methods: {
		async fetchCronJobs(pagination) {
			const request = this.$ravello.request()
				.to('system')
				.to('cron')
				.fromPagination(pagination)

			try {
				this.jobs = await request.get()
				if (this.count === -1) {
					const count = await request.count()
					this.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		updateRemaining() {
			this.updateInterval = setInterval(() => {
				this.now.add(1, 'seconds')
				this.jobs = this.jobs.map((event) => {
					if (!event.disabled && event.ttl) {
						event.ttl -= 1
					}
					return event
				})
			}, 1000)
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.to('system')
					.to('cron')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
	beforeDestroy() {
		clearInterval(this.updateInterval)
	},
}
</script>
